import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-receiptmsg',
  templateUrl: './receiptmsg.component.html',
  styleUrls: ['./receiptmsg.component.scss']
})
export class ReceiptmsgComponent implements OnInit {
  pdfUrl: any;
  pdfUrlWhatsapp: any;
  ymLogoPng: string;

  constructor(
    public dialogRef: MatDialogRef<ReceiptmsgComponent>,private authservice:AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
      this.ymLogoPng=environment.ym_logo_png;
                
  }

  ngOnInit(): void {
    console.log('data', this.data);
    this.downloadPdf(this.data.senderDetails.object.transactionReference,'whatsapp');
   
  }
  cancel(){
    this.dialogRef.close();
  }
  proceed(){
    this.dialogRef.close();
  }
 
   downloadPdf(transactionReference,value){
  
    this.authservice.downloadPdf(transactionReference).subscribe((res:any)=>{
      if(res.status_code==1){
        if(value == 'whatsapp'){
          this.pdfUrlWhatsapp=res.receiptURl;
          console.log(this.pdfUrlWhatsapp);
            }else{
              window.open(res.receiptURl);

            }
  
      }
  
    })
  
   }
   
}
